/* import __COLOCATED_TEMPLATE__ from './github-updates.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

export default Component.extend({
  intercomEventService: service(),
  router: service(),
  appService: service(),
  app: readOnly('appService.app'),
  gitHubEnabled: readOnly('app.hasEnabledGithubIntegration'),

  actions: {
    transitionToGithub() {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'clicked',
        object: 'link_to_github_settings',
      });
      return this.router.transitionTo('apps.app.appstore.index', {
        queryParams: {
          app_package_code: 'github',
        },
      });
    },
  },
});
